export default __webpack_public_path__ + "static/media/AvenirNext-Medium.9520daff.woff2";